import { Box } from "ui/box/box";
import { SEARCH_GLYPH_SX } from "ui/search-field/search-field.styles";
import { type SearchFieldProps } from "ui/search-field/search-field.types";
import { useSearchField } from "ui/search-field/use-search-field";
import { TextField } from "ui/text-field/text-field";

import Icons from "assets";

const DEFAULT_ACCESSIBLE_NAME = "Search";

/** A `TextField` with the search glyph at its start; the term reaches `onChange` trimmed and debounced. */
export const SearchField = ({ onChange, placeholder, sx }: SearchFieldProps) => {
  const { value, handleChange, handleClear } = useSearchField({ onChange });

  return (
    <TextField
      name="search"
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      onClear={handleClear}
      startIcon={<Box component={Icons.Search} aria-hidden sx={SEARCH_GLYPH_SX} />}
      data-testid="search-text-input"
      slotProps={{ input: { "aria-label": placeholder || DEFAULT_ACCESSIBLE_NAME } }}
      sx={sx}
    />
  );
};
